export default __webpack_public_path__ + "static/media/3.97d9680e.png";